export default {
  title: '¿Tienes SOSAFE?',
  subtitle: 'Sí tienes, prueba con los mensajes privados de SOSAFE',
  action: 'SI',
};
